export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'job_type/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'job_type/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'job_type/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'job_type/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/JobType.js